import { Machine } from "xstate";
import { AssetMasterModule } from "@/store/modules/asset.module";
import { toaster } from "@/utilities/toaster";
const assetMasterMachine = Machine({
    id: "assetMasterMachine",
    context: {
        id: "",
    },
    initial: "idle",
    states: {
        idle: {
            always: [{ target: "gettingAssetTypes" }],
        },
        gettingAssetTypes: {
            invoke: {
                id: "gettingAssetTypes",
                src: (ctx, event) => {
                    return AssetMasterModule.GetAssetTypes();
                },
                onDone: { target: "loadedAssetTypes" },
                onError: { target: "serviceUnavailable" },
            },
        },
        loadedAssetTypes: {
            on: {
                ADDING_ASSET_TYPE: { target: "addingAssetType" },
                EDIT_ASSET_TYPE: { target: "editingAssetType" },
                DELETE_ASSET_TYPE: { target: "deleteAssetType" },
                LOAD_ASSET_TYPE_PROPERTIES: { target: "gettingAssetTypeProperties" },
            },
        },
        addingAssetType: {
            tags: "showAddAssetTypeUI",
            on: {
                SAVE_ASSET_TYPE: { target: "savingAssetType" },
                CANCEL_ADDING_ASSET_TYPE: { target: "loadedAssetTypes" },
            },
        },
        savingAssetType: {
            tags: "showAddAssetTypeUI",
            invoke: {
                id: "savingAssetType",
                src: (ctx, evt) => {
                    return AssetMasterModule.AddAssetType(evt.newAssetType);
                },
                onDone: { target: "gettingAssetTypes", actions: ["showSuccessMessage"] },
                onError: { target: "gettingAssetTypes" },
            },
        },
        editingAssetType: {
            tags: "showEditAssetTypeUI",
            on: {
                UPDATE_ASSET_TYPE: { target: "updateAssetType" },
                CANCEL_EDITING_ASSET_TYPE: { target: "loadedAssetTypes" },
            },
        },
        updateAssetType: {
            tags: "showEditAssetTypeUI",
            invoke: {
                id: "updateAssetType",
                src: (ctx, evt) => AssetMasterModule.UpdateAssetType(evt.updateAssetType),
                onDone: { target: "gettingAssetTypes", actions: ["showSuccessMessage"] },
                onError: { target: "gettingAssetTypes" },
            },
        },
        deleteAssetType: {
            tags: "showAssetTypeDeleteUI",
            on: {
                DELETING_ASSET_TYPE: { target: "deletingAssetType" },
                CANCEL_DELETE_ASSET_TYPE: { target: "gettingAssetTypes" },
            },
        },
        deletingAssetType: {
            tags: "showAssetTypeDeleteUI",
            invoke: {
                id: "deletingAssetType",
                src: (ctx, evt) => AssetMasterModule.DeleteAssetTypeById(evt.assetTypeId),
                onDone: { target: "gettingAssetTypes", actions: ["showSuccessMessage"] },
                onError: { target: "deleteAssetType" },
            },
        },
        gettingAssetTypeProperties: {
            tags: "showListAssetTypePropertiesUI",
            invoke: {
                id: "gettingAssetTypeProperties",
                src: (ctx, event) => {
                    return AssetMasterModule.GetAssetTypeProperties(ctx.id);
                },
                onDone: { target: "loadedAssetTypeProperties" },
                onError: { target: "serviceUnavailable" },
            },
        },
        loadedAssetTypeProperties: {
            tags: "showListAssetTypePropertiesUI",
            initial: "listing",
            on: {
                ADDING_ASSET_TYPE_PROPERTY: { target: ".addAssetTypeProperty" },
                SET_CONFIGURATION_ORDERS: { target: ".setConfigurationOrders" },
                EDITING_ASSET_TYPE_PROPERTY: { target: ".editAssetTypeProperty" },
                CLOSE_ASSET_TYPE_PROPERTIES: { target: "gettingAssetTypes" },
                DELETE_ASSET_TYPE_PROPERTY: { target: ".deleteAssetTypeProperties" },
                LOAD_ASSET_TYPE_PROPERTIES: { target: "gettingAssetTypeProperties" },
            },
            states: {
                listing: {},
                addAssetTypeProperty: {
                    tags: "showAddAssetTypePropertyUI",
                    on: {
                        SAVING_ASSET_TYPE_PROPERTY: { target: "savingAssetTypeProperty" },
                        CANCEL_ASSET_TYPE_PROPERTY: { target: "listing" },
                    },
                },
                savingAssetTypeProperty: {
                    tags: "showAddAssetTypePropertyUI",
                    invoke: {
                        id: "savingAssetTypeProperty",
                        src: (ctx, evt) => AssetMasterModule.AddAssetTypeProperty(evt.newAssetTypeProperty),
                        onDone: { target: "#assetMasterMachine.loadedAssetTypeProperties", actions: ["showSuccessMessage"] },
                        onError: { target: "addAssetTypeProperty" },
                    },
                },
                setConfigurationOrders: {
                    tags: "showSetConfigurationUI",
                    on: {
                        SAVING_CONFIGURATION_ORDER: { target: "savingConfigurationOrder" },
                        CLEAR_ALL_CONFIGURATION_ORDER: { target: "clearAllConfigurationOrder" },
                        EXIT_CONFIGURATION: { target: "#assetMasterMachine.loadedAssetTypeProperties" },
                    },
                },
                savingConfigurationOrder: {
                    tags: "savingSetConfigurationUI",
                    invoke: {
                        id: "savingConfigurationOrder",
                        src: (_ctx, evt) => AssetMasterModule.SetConfigurationOrder(evt.assetTypePropertyId),
                        onDone: { target: "setConfigurationOrders" },
                        onError: { target: "setConfigurationOrders" },
                    },
                },
                clearAllConfigurationOrder: {
                    tags: "clearAllConfigurationUI",
                    invoke: {
                        id: "clearAllConfigurationOrder",
                        src: (ctx, evt) => AssetMasterModule.ClearConfiguration(evt.assetTypePropertyId),
                        onDone: { target: "setConfigurationOrders" },
                        onError: { target: "setConfigurationOrders" },
                    },
                },
                editAssetTypeProperty: {
                    tags: "showAssetTypePropertyEditorUI",
                    on: {
                        UPDATE_ASSET_TYPE_PROPERTY: { target: "updatingAssetTypeProperty" },
                        CANCEL_EDIT_ASSET_TYPE_PROPERTY: { target: "listing" },
                    },
                },
                updatingAssetTypeProperty: {
                    tags: "showAssetTypePropertyEditorUI",
                    invoke: {
                        id: "updatingAssetTypeProperty",
                        src: (ctx, evt) => AssetMasterModule.UpdateAssetTypeProperty(evt.updatingAssetTypeProperty),
                        onDone: { target: "#assetMasterMachine.loadedAssetTypeProperties", actions: ["showSuccessMessage"] },
                        onError: { target: "editAssetTypeProperty" },
                    },
                },
                deleteAssetTypeProperties: {
                    tags: "showAssetTypePropertyDeleteUI",
                    on: {
                        DELETING_ASSET_TYPE_PROPERTY: { target: "deletingAssetTypeProperties" },
                        CANCEL_DELETE_ASSET_TYPE_PROPERTY: { target: "listing" },
                    },
                },
                deletingAssetTypeProperties: {
                    tags: "showAssetTypePropertyDeleteUI",
                    invoke: {
                        id: "deletingAssetTypeProperties",
                        src: (ctx, evt) => AssetMasterModule.DeleteAssetTypePropertiesById(evt.assetTypePropertyId),
                        onDone: { target: "#assetMasterMachine.gettingAssetTypeProperties", actions: ["showSuccessMessage"] },
                        onError: { target: "deleteAssetTypeProperties" },
                    },
                },
            },
        },
        serviceUnavailable: { type: "final" },
    },
}, {
    actions: {
        showSuccessMessage: (context, event) => {
            toaster.ShowSuccess(event.data.successMessages[0]);
        },
    },
    guards: {},
    activities: {},
    services: {},
});
export default assetMasterMachine;
